import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';
import type { RenderResult } from '@inter-ikea-kompis/web-component';

/**
 * Popover class.
 *
 * @slot Slot for the popover content.
 */
export default class PopoverPadding extends KompisElement {
	// Theme.
	@property({ type: Object, required: true })
	public theme!: ITheme;

	/**
	 * Renders the component.
	 *
	 * @returns Template.
	 */
	public override render(): RenderResult {
		const { spacing } = this.theme;
		return html`
			<style>
				:host {
					display: block;
					padding: ${spacing.space100 / 16}rem;
				}
			</style>
			<slot></slot>
		`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'kompis-popover-padding': PopoverPadding;
	}
}
